import React, { useState, useEffect } from 'react';
import { cleanDict2IfNotInDict1, cleanNodes, clearCache, removeNonStringValuesFromDict, store } from './foo';
import { _libName, _pathSeparator, _rootName } from './constants';
import { IonButton, IonIcon } from '@ionic/react';
import { colorWandOutline } from 'ionicons/icons';
import { useTreeStore } from './stateManagement/treeZustand';
import { useUserStore } from './stateManagement/userZustand';
import { UpdateClickData } from './types';
import { updateClickDataToFirestore } from '../foo/user';

interface UpdateSectionProps {
    text: string;
}

const UpdateButton: React.FC<UpdateSectionProps>= ({ text }) => {
  const { nodes, l2Image, l2Audio, l2Visibility, l2Color, setNodes, setL2Image, setL2Audio, setL2Visibility, setL2Color } = useTreeStore();
  const { updateIsSubscribedFromDB, isSubscribed, userEmail, userUniqueId, checkoutSessionOK, subTkn, hasLoggedIn } = useUserStore();
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then(reg => {
        if (reg) {
          setRegistration(reg);
        } else {
          setRegistration(null);
        }
      });
    }
  }, []);

  const getDateStr = () => {
    const timestamp = Date.now();
    const date = new Date(timestamp);

    const formattedDate = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date);

    return formattedDate;
  }

  const updateServiceWorker = async () => {
    
    //Data Correction Here
    setL2Image(removeNonStringValuesFromDict(l2Image));

    //Data Cleaning
    const newNodes = cleanNodes(nodes,[_rootName+_pathSeparator+_libName]);
    setL2Image(cleanDict2IfNotInDict1(newNodes, l2Image));
    setL2Audio(cleanDict2IfNotInDict1(newNodes, l2Audio));
    setL2Visibility(cleanDict2IfNotInDict1(newNodes, l2Visibility));
    setL2Color(cleanDict2IfNotInDict1(newNodes, l2Color));
    setNodes(newNodes);

    await updateIsSubscribedFromDB();

    if (registration) {
      await registration.update();
    }
    await clearCache();

    const userData : UpdateClickData = {
      date: getDateStr(),
      isSubscribed: isSubscribed,
      userEmail: userEmail,
      userUID: userUniqueId,
      checkoutSessionOK: checkoutSessionOK,
      subTkn: subTkn,
      hasLoggedIn: hasLoggedIn

    };

    await updateClickDataToFirestore(userData);
    //hard reload to update the app
    window.location.reload();
  };

  return (
    <IonButton expand="block" color="light" onClick={updateServiceWorker}>
    <IonIcon icon={colorWandOutline} slot="start" />
      {text}
    </IonButton>
  );
};

export default UpdateButton;